document.addEventListener("DOMContentLoaded", function (e) {
    const lightbox = document.getElementById('lightbox');
    const membershipCard = document.querySelector('.membershipcard');
    var close = document.getElementById('close');
    var body = document.querySelector('body');

    function closeLightbox() {
        lightbox.style.display = 'none';
        body.style.overflow = 'auto';
    }

    if (membershipCard) {
        membershipCard.addEventListener("click", function (e) {
            e.stopPropagation();
            if (window.innerWidth < 768) {
                lightbox.style.display = 'block';
                body.style.overflow = 'hidden';
            }
        });
        lightbox.addEventListener('click', function (e) {
            if (e.target === lightbox) {
                closeLightbox();
            }
        });
    }

    if (close) {
        close.addEventListener("click", function (e) {
            e.stopPropagation();
            closeLightbox();
        });
    }
});